import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Autosuggest from 'ati-ui-react/components/Autosuggest';
import isEmpty from 'lodash/isEmpty';
import updateUrlParam from 'utils/updateUrlParam';
import SearchParameter from '../SearchParameter/SearchParameter';

const Model: FC = observer(() => {
  const { truckBrandsStore, findTrucksStore, searchModelsStore } = useStores();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const fieldsModel = findTrucksStore.fields.model;
    const modelStoreValue = searchModelsStore.value;

    if (fieldsModel !== modelStoreValue || isEmpty(modelStoreValue)) {
      params.delete('model');
      updateUrlParam(params);
      return;
    }

    params.set('model', fieldsModel);
    updateUrlParam(params);
  }, [findTrucksStore.fieldsValues]);

  const handleSuggestionsFetchRequested = ({ value }: { value: string }): void => {
    searchModelsStore.getModel({
      prefix: value,
      ...(truckBrandsStore.value && { brand_id: truckBrandsStore.value }),
    });
  };

  const onChange = (value: string): void => {
    searchModelsStore.onChange(value);
  };

  const handleSuggestionSelected = (event: any, { suggestion }: any): void => {
    searchModelsStore.getSuggestionBrand(suggestion.brand);

    findTrucksStore.updateBrandModel({ field: 'model', name: suggestion.model });
  };

  const handleSuggestionsClearRequested = (): void => {
    if (searchModelsStore.value === '') {
      searchModelsStore.resetModelProperty();
    }
  };

  return (
    <SearchParameter caption="Модель" model>
      <Autosuggest
        id=""
        dataQa="model-form-autosuggest-qa"
        wrapperClassName="model"
        placeholder="Например, 2879"
        searchProperty="model"
        valueProperty="model"
        onChange={onChange}
        onSuggestionsFetchRequested={handleSuggestionsFetchRequested}
        suggestions={searchModelsStore.suggestions}
        noFog
        onSuggestionSelected={handleSuggestionSelected}
        onSuggestionsClearRequested={handleSuggestionsClearRequested}
        value={searchModelsStore.value}
      />
    </SearchParameter>
  );
});

export default Model;
